const externalRoutes = ['/appointment/create', '/appointment/create/success', '/appointment/update'];

export const checkExternalInitialization = () => {
  // check prev initialization
  const prevInit = localStorage.getItem('externalInit') === 'true';

  // check if this not an external init route
  if (!externalRoutes.some(item => window.location.href.includes(item)) && prevInit) {
    localStorage.removeItem('externalInit');
    localStorage.removeItem('jwt');

    return false;
  }

  // verify if there is a query token, means external initialization
  const token = new URLSearchParams(window.location.search).get('token');
  const isExternalLogin = window.location.pathname.includes('/externalLogin');

  const result = (!!token || prevInit) && !isExternalLogin;
  if (result) localStorage.setItem('externalInit', 'true');

  return result;
};
